import { isValid, isAfter, isBefore } from 'date-fns';

export const MAX_CHARS = 50;

export const isRequired = (message: string) => ({
  required: message,
});

export const isValidEmail = (message: string) => ({
  pattern: { value: /^\S+@\S+\.\S+$/, message },
});

export const isValidOrderNumber = (orderNumberMaxLength: number, message: string) => ({
  pattern: {
    value: new RegExp(
      `^([a-zA-Z0-9]{6}(?:[a-zA-Z0-9]{${orderNumberMaxLength - 6}})?|^\\d{4}-\\d{3}-\\d{3})$`,
    ),
    message,
  },
});

export const isValidDate = (message: string) => ({
  validate: {
    checkIsDateValid: (date: unknown) => isValid(date) || message,
  },
});

export const isAfterDate = (minDate: Date | undefined, message: string) => ({
  validate: {
    checkIsAfter: (value: Date) => {
      if (!minDate) {
        return true;
      }

      if (!isValid(value) || !isValid(minDate)) {
        return true;
      }

      if (isAfter(value, minDate)) {
        return true;
      }

      return message;
    },
  },
});

export const isBeforeDate = (maxDate: Date | undefined, message: string) => ({
  validate: {
    checkIsBefore: (value: Date) => {
      if (!maxDate) {
        return true;
      }

      if (!isValid(value) || !isValid(maxDate)) {
        return true;
      }

      if (isBefore(value, maxDate)) {
        return true;
      }

      return message;
    },
  },
});

export const isNotNull = (message: string) => ({
  validate: {
    checkIsNotNull: (value: unknown) => {
      if (value === null) {
        return message;
      }

      return true;
    },
  },
});
